import React from 'react';
import ParseJobForm from './ParseJobForm';

interface ParseJob {
  id: number;
  name?: string;
  chunk_size: number;
  chunk_mode: string;
  chunking_strategy?: string;
  start_page: number;
  end_page: number;
  response_payload?: any;
  raw_chunks?: Array<{
    page_number: number;
    content: string;
  }>;
}

interface Document {
  id: number;
  name: string;
  page_count: number;
  parse_jobs: ParseJob[];
}

interface ParseJobEditProps {
  document: Document;
  parseJob: ParseJob;
  chunkModes: string[];
  chunkingStrategies: string[];
  previousParseJob?: ParseJob;
  nextParseJob?: ParseJob;
}

export default function ParseJobEdit({ 
  document, 
  parseJob, 
  chunkModes,
  chunkingStrategies,
  previousParseJob,
  nextParseJob
}: ParseJobEditProps) {
  return (
    <ParseJobForm 
      document={document}
      parseJob={parseJob}
      chunkModes={chunkModes}
      chunkingStrategies={chunkingStrategies}
      previousParseJob={previousParseJob}
      nextParseJob={nextParseJob}
    />
  );
}